const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeEmail = (value) => String(value ?? '').trim().toLowerCase();

export const isEmail = (value) => EMAIL_RE.test(String(value ?? '').trim());

export const sameChain = (a = [], b = []) => a.length === b.length && a.every((v, i) => v === b[i]);

/** Returns a lookup: communicator email → [their manager, that manager's manager, …]. */
export function buildChainLookup(lines) {
  const supervisorOf = {};
  for (const line of lines) {
    const employee = normalizeEmail(line.employeeEmail);
    const supervisor = normalizeEmail(line.supervisorEmail);
    if (employee && supervisor && employee !== supervisor) supervisorOf[employee] = supervisor;
  }
  const cache = {};
  return (email) => {
    const start = normalizeEmail(email);
    if (!start) return [];
    if (!cache[start]) {
      const chain = [];
      const seen = new Set([start]);
      let current = supervisorOf[start];
      while (current && !seen.has(current) && chain.length < 20) {
        chain.push(current);
        seen.add(current);
        current = supervisorOf[current];
      }
      cache[start] = chain;
    }
    return cache[start];
  };
}

/** Why a cycle's My Team rollups may be missing or wrong. */
export function rollupHealth(comps, lines) {
  const chainOf = buildChainLookup(lines);
  const people = new Set(lines.flatMap((l) => [normalizeEmail(l.employeeEmail), normalizeEmail(l.supervisorEmail)]));
  const communicators = [...new Set(comps.map((c) => normalizeEmail(c.communicatorEmail)).filter(Boolean))];
  return {
    invalidLines: lines.filter((l) => !isEmail(l.employeeEmail) || !isEmail(l.supervisorEmail)).length,
    communicators: communicators.length,
    unmatchedCommunicators: communicators.filter((e) => !people.has(e)).length,
    staleChains: comps.filter((c) => !sameChain(c.supervisorChain, chainOf(c.communicatorEmail))).length,
  };
}
